import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Image as ImageIcon } from "lucide-react";
import api from "../../lib/api";
import { BLOG_POSTS } from "../../content/blogPosts";
import { autoFigure, loadBlogCovers } from "./BlogCover";

// Admin : chiffre clé et fond de chaque couverture d'article (vide = automatique).
export const AdminBlogCovers = () => {
  const [d, setD] = useState({});
  useEffect(() => { loadBlogCovers(true).then(setD); }, []);
  const save = async (slug, patch) => {
    const next = { ...(d[slug] || { figure: "", theme: "" }), ...patch };
    setD({ ...d, [slug]: next });
    try { await api.put(`/admin/blog/covers/${slug}`, next); loadBlogCovers(true); toast.success("Couverture mise à jour"); } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };
  return (
    <div className="bg-white rounded-[10px] border border-brand-soft p-6 space-y-3" data-testid="admin-blog-covers">
      <h3 className="font-semibold text-brand-greenDeep flex items-center gap-2"><ImageIcon className="w-4 h-4" /> Couvertures du blog</h3>
      <p className="text-xs text-brand-green/50">Le chiffre clé est trouvé automatiquement ; saisissez-en un autre pour le remplacer. Fond : alterné par défaut.</p>
      {BLOG_POSTS.map((p) => {
        const o = d[p.slug] || {};
        return (
          <div key={p.slug} className="grid sm:grid-cols-[1fr_140px_140px] gap-2 items-center text-sm border-t border-brand-soft pt-2">
            <span className="text-brand-greenDeep truncate" title={p.title}>{p.title}</span>
            <input key={`${p.slug}-${o.figure || ""}`} defaultValue={o.figure || ""} placeholder={autoFigure(p)} onBlur={(e) => e.target.value !== (o.figure || "") && save(p.slug, { figure: e.target.value })} className="input" data-testid={`admin-cover-figure-${p.slug}`} />
            <select value={o.theme || ""} onChange={(e) => save(p.slug, { theme: e.target.value })} className="input" data-testid={`admin-cover-theme-${p.slug}`}>
              <option value="">Alterné</option><option value="graphite">Graphite</option><option value="ivoire">Ivoire</option>
            </select>
          </div>
        );
      })}
    </div>
  );
};
